import PropTypes from 'prop-types'
import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import { Col, Panel } from 'react-bootstrap'
import { defaultPayingGuestValue, guestEntryFields } from '../redux/formSchema'
import { getGuestInitFields } from '../redux/stateUtils'
import { reduxForm } from 'redux-form'
import { resetRoomBookingState } from '../redux/actions'
import { roomSearchParamsSelector } from '../redux/modules/searchParamsModule'
import history from '../history'

@autobind
class BookingSuccess extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    rooms: PropTypes.object,
    payment: PropTypes.object,
    dp: PropTypes.object
  }

  componentWillMount() {
    let {
      history: { prevPage }
    } = this.props
    if (prevPage !== 'PAYMENT') {
      history.push('/search')
    }
  }

  componentWillUnmount() {
    let { dispatch } = this.props
    dispatch(resetRoomBookingState())
  }

  render() {
    return (
      <Col sm={12} md={8} mdOffset={2}>
        <Panel>
          <div className='success-text'>
            <h1>Success!</h1>
            <p style={{ fontSize: '2rem' }}>
              Your booking was successful. We have sent you an email with a
              summary of your booking and some information about your upcoming
              visit.
            </p>
            <br />
            <strong>Rooms booked:</strong> {this.props.bookedData.roomNames}
            <br />
            <strong>Amount paid:</strong> ${this.props.bookedData.paidAmount}
            <br />
            <strong>Dates of stay: </strong>
            {this.props.bookedData.uiCheckInDate} -{' '}
            {this.props.bookedData.uiCheckOutDate}
            <br />
          </div>
        </Panel>
      </Col>
    )
  }
}

function selectProps(state) {
  return {
    searchParams: roomSearchParamsSelector(state),
    rooms: state.rooms,
    payment: state.payment,
    auth: state.common.authentication,
    history: state.common.history,
    roomPrices: state.common.roomPrices,
    formErrors: state.common.formErrors,
    searchResults: state.roomSearch.results,
    bookedData: state.roomSearch.bookedData
  }
}

let reduxFormFunc = reduxForm(
  {
    form: 'roomSelection',
    destroyOnUnmount: false,
    fields: guestEntryFields,
    initialValues: getGuestInitFields(defaultPayingGuestValue)
  },
  selectProps
)

export default reduxFormFunc(BookingSuccess)



// WEBPACK FOOTER //
// ./src/containers/bookingSuccess.js